/* oxlint-disable sorare/no-detached-fragments */
import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import { TokenLoyaltyBoost } from '#src/components/token/Token/TokenLoyaltyBoost/index.tsx';

import type {
  UnsealingCardsMutation,
  UnsealingCardsMutationVariables,
} from './__generated__/useUnsealingMutation.graphql.ts';

const mutation = gql`
  mutation UnsealingCardsMutation($input: unsealCardsInput!) {
    unsealCards(input: $input) {
      cards {
        slug
        pictureUrl
        ...TokenLoyaltyBoost_anyCard
      }
      errors {
        message
      }
    }
  }
  ${TokenLoyaltyBoost.fragments.anyCard}
` as TypedDocumentNode<UnsealingCardsMutation, UnsealingCardsMutationVariables>;

export const useUnsealingMutation = () => {
  return useMutation(mutation, {
    showErrorsWithSnackNotification: true,
  });
};
